/* eslint-disable function-paren-newline */
import * as React from 'react';
import styled, { css } from 'styled-components';
import { LibraryBooks } from '@material-ui/icons';
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';
import useTablePage from '../hooks/useTablePage';
import { ModalDefaultDraggable,
} from '../molecules';
import { DATETIME_FORMAT, DEFAULT_DATE_FORMAT, GET_ALL_QUERY_PARAMS } from '../constants';
import { ReportTableType } from "../api/reports";
import { getActivitiesList, getActivitiesStatusList, getCustomActivities, getPermitActivities, updatePermitActivity } from "../api/activities";
import { getCurrentUser } from "../api/userSettings";
import { formatDateTime } from "../utils/formatDate";
import useManuallyUpdate from "../hooks/useManuallyUpdate";
import DashboardLayout from "../layouts/DashboardLayout";
import Table from "../organisms/Table";
import { getProjects } from "../api/projects";
import { getPermits } from "../api/permits";
import { getUsers } from "../api/users";
import { USER_TYPES_VALUES } from "../constants/forms";
import { getVocabulariesDataList } from "../api/vocabulary";
import ModalInfo from "../molecules/ModalInfo";
import tableColumnsFormatter from "../utils/tableColumnsFormatter";
import PermitActivitiesForm from "../forms/PermitActivitiesForm";
import DocumentsPage from "./Permits/DocumentsPage";
import { modifiedGetReviews } from '../utils/allActivitiesPageRequests';
import ReviewsPageMobile from './Responsive/PendingReviewsMobile';
import { setCurrentUserId } from '../redux/slices/meSlice';
import { setIsUpdateTable } from '../redux/slices/allActivitiesSlice';
import DocumentsDetailedPage from './Permits/DocumentsDetailedPage';

const ReviewsPage = () =>
{
 const {
    errors,
    } = useForm<ReportTableType>({
    mode: 'onChange',
  });
 const [
    tableManuallyUpdate,
    updateTable,
  ] = useManuallyUpdate();
 const dispatch = useDispatch();
 const [isAddDocument, setAddDocument] = React.useState(
    false,
  );
  const [
    isDownloadAllDocs,
    setDownloadAllDocs,
  ] = React.useState(false);
  const [
    isDocsAvailable,
    setDocsAvailable,
  ] = React.useState(false);
  const [
    isDocsWaitingOnClient,
    setDocsWaitingOnClient,
  ] = React.useState(false);
  const [isSendDocs, setSendDocs] = React.useState(false);
  const [currentUser, setCurrentUser] = React.useState(
    null,
  );
  const [
    permit,
    setPermit,
  ] = React.useState(null);

  const {
    isModalOpen,
    modalError,
    modalSuccess,
    modalTitle,
    modalErrorTitle,
    values,
    createOrUpdate,
    handleEdit,
    handleCloseModal,
    handleCloseModalInfo,
   } = useTablePage({
     updateEndpoint: updatePermitActivity,
     modalUpdateTitle: 'Update Review',
   });

  const [initialValues, setInitialValues] = React.useState(
    null,
  );
  const [customReviewsData, setCustomReviewsData] = React.useState(null);
  const [
    documents,
    showDocuments,
  ] = React.useState(null);
  const handleEditModal = data => {
    if (data) {
      setPermit(data?.permitId);
      setInitialValues(data);
      handleEdit(data);
    }
  };

  const refreshTable = () => {
    dispatch(setIsUpdateTable(true));
    updateTable();
  };

  const closeInfoModal = () => {
    setInitialValues(null);
    showDocuments(undefined);
    refreshTable();
    handleCloseModalInfo();
  };

  const closeEditModal = () => {
    setInitialValues(null);
    refreshTable();
    handleCloseModal();
  };

  const closeDocumentsModal = () => {
    showDocuments(undefined);
    refreshTable();
  };

  React.useEffect(() => {
      Promise.all([
        getCurrentUser(),
    ]).then(
      ([
        currentUserResponse,
      ]) => {
        getCustomActivities({
          is_deleted: false,
          inspector_id: currentUserResponse?.data?.id,
          event_type: "Activity",
          activity_type_name: "Reviews",
        }).then(reviews => {
          const modifiedData = reviews?.data?.results?.filter(el => !el?.reviewTypeComment?.length)?.map(el => el?.id);
          setCustomReviewsData(modifiedData);
        });
        setCurrentUser(currentUserResponse.data.id);
        dispatch(setCurrentUserId(currentUserResponse.data.id));
      },
      );
  }, []);

 const reviewColumns = column => {
  if (
    [
      'id',
      'inspector',
      'isEmergency',
      'documentFile',
      'contact',
      'isCompleted',
      'amount',
      'activityType',
      'information',
      'permitId',
      'reviewTypeName',
      'fees',
      'feeNames',
      'attachments',
      // 'lastComment',
      'permitName',
      'contactFirstName',
      'contactLastName',
      'assignedToFirstName',
      'assignedToLastName',
      'companyName',
      'activityTitleName',
      'activityTypeName',
      'projectJurisdiction',
      'statusName',
      'contactId',
      'type',
      'reviewer',
      'projectId',
      'createdAt',
      'createdBy',
      'completedAt',
      'completedBy',
      'conditionName',
      'selectedDocuments',
      'reviewTypeComment',
      'reviewTypeId',
      'hasBranchAccess',
    ].includes(column)
  ) {
    return null;
  }

  switch (column) {
    case 'title':
      return 'Activity Title';
    case 'status':
      return 'Activity Status';
    case 'projectName':
      return 'Project Name';
    case 'permit':
      return 'Permit Name';
    case 'assignedTo':
      return 'Assigned To';
    default:
      return tableColumnsFormatter(column);
  }
};

 const reviewColumnsOrder = [
  'projectName',
  'permit',
  'jurisdiction',
  'permitNumber',
  'reviewType',
  'title',
  'status',
  'followUp',
 ];

 const additionalActions = rowValue => {
    return [
      {
        title: 'View Documents',
        handler: () => showDocuments(rowValue),
        Icon: LibraryBooks,
      },
    ];
  };

  return (
    <DashboardLayout>
      <ReviewsPageMobile rows={modifiedGetReviews} />
      <Container>

        { currentUser && <Table
          customSearch
          rows={modifiedGetReviews}
          columns={reviewColumns}
          onEdit={handleEditModal}
          onDelete={null}
          columnsOrder={reviewColumnsOrder}
          colorSchema
          isActivityTable
          activityType="InspectorReviews"
          additionalRequestParams={{
            inspectorId: currentUser,
            eventType: "Activity",
            activityTypeName: 'Reviews',
          }}
          manuallyUpdate={tableManuallyUpdate}
          additionalActions={additionalActions}
          reviewerCommentData={customReviewsData}
        /> }
        {isModalOpen && initialValues && (
        <ModalDefaultDraggable
          title={modalTitle}
          onClose={closeEditModal}
          wide
        >
          <PermitActivitiesForm
            onSubmit={createOrUpdate}
            initialValues={initialValues}
            modalError={modalError}
            addButtonText="Create"
            updateButtonText="Update"
            initialErrors={errors}
            permit={permit}
              // isReadOnly={true}
          />
        </ModalDefaultDraggable>
      )}

        {documents && (
        <ModalDefaultDraggable
          title="Document Review"
          onClose={closeDocumentsModal}
          wide
        >
          <DocumentsDetailedPage
            row={documents}
            work={null}
            building={null}
            isAddDocument={false}
            setAddDocument={setAddDocument}
            isDownloadAllDocs={false}
            setDocsAvailable={setDocsAvailable}
            setDownloadAllDocs={setDownloadAllDocs}
            setDocsWaitingOnClient={setDocsWaitingOnClient}
            isSendDocs={false}
            setSendDocs={setSendDocs}
            isInspector
            initialValues={documents}
            onSubmit={function (data: any): void {
                throw new Error('Function not implemented.');
              }}
          />
        </ModalDefaultDraggable>
      )}
        {(modalSuccess || modalError) && (
        <ModalInfo
          timeToClose={5000}
          isError={modalError}
          onClose={closeInfoModal}
          errorMsg={modalErrorTitle}
        />
      )}

      </Container>
    </DashboardLayout>
  );
};

const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 20px 16px 0;

  @media only screen and (max-width: 1366px) {
    display: none;
  }

  @media only screen and (max-width: 840px) {
    padding: 12px 12px 0;
  }
`;

const InnerContainer = styled.div`
  width: calc(100% + 4px);
  background: var(--secondary);
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: -2px;
  padding: 0 24px;
`;

const FormContainer = styled.form`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  > div {
    width: auto;
    padding: 0;
    margin: 0 24px 0 0;

    &:last-child {
      margin: 0;
    }
  }
`;

export default ReviewsPage;
